export default "__VITE_ASSET__3dcc7310__"